import DBOperations from "src/utils/dbOperations";
import Exception from "src/utils/exception";

async function getPlantLocationList(tableName, config) {
  try {
    return await DBOperations.fetchData(
      tableName,
      config.fetchDeleted,
      config.searchTxt,
      config.sortField,
      config.sortOrder,
      config.page,
      config.rows,
      config.fetchAll,
      config.queryParams
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getPlantLocationList
};
